module.exports = __webpack_public_path__ + "img/phone.83989526.png";